
<div ref="resizable" class="resizable">
  <div ref="content" class="content">
    <slot></slot>
  </div>
</div>
